class ContactFlowApi {
  getMessages() {
  

    let m2 = [{
      ContactId: "895a1290-243d-4326-ae99-28a75b733f32",
      ContactFlowId:
        "arn:aws:connect:us-east-1:480876436154:instance/445dd2de-e303-485f-8c09-348bbcf4b582/contact-flow/a216def9-acd0-4763-9b98-a768d9558170",
      ContactFlowName: "NorthCodeBankingDemoBalanceXXX",
      ContactFlowModuleType: "GetUserInput",
      Timestamp: "2023-01-20T12:14:38.467Z",
      Parameters: {
        TextToSpeechType: "ssml",
        Timeout: "5000",
        Text: '<speak>\n<prosody rate="medium">\nPlease press one for current balance or press two for balance as of last statement.\n</prosody>\n</speak>',
        Voice: "Joanna",
        MaxDigits: "1",
      },
    },
    {
      Results: "Success",
      ContactId: "895a1290-243d-4326-ae99-28a75b733f32",
      ContactFlowId:
        "arn:aws:connect:us-east-1:480876436154:instance/445dd2de-e303-485f-8c09-348bbcf4b582/contact-flow/a216def9-acd0-4763-9b98-a768d9558170",
      ContactFlowName: "NorthCodeBankingDemoBalanceXXX",
      ContactFlowModuleType: "PlayPrompt",
      Timestamp: "2023-01-20T12:14:48.278Z",
    },
    {
      ContactId: "895a1290-243d-4326-ae99-28a75b733f32",
      ContactFlowId:
        "arn:aws:connect:us-east-1:480876436154:instance/445dd2de-e303-485f-8c09-348bbcf4b582/contact-flow/a216def9-acd0-4763-9b98-a768d9558170",
      ContactFlowName: "NorthCodeBankingDemoBalanceXXX",
      ContactFlowModuleType: "PlayPrompt",
      Timestamp: "2023-01-20T12:14:48.349Z",
      Parameters: {
        TextToSpeechType: "ssml",
        SpeakingStyle: "",
        Text: '<speak>\n<amazon:auto-breaths>\n<prosody rate="medium" >\n<prosody rate="-4%" >\nThank you for calling NorthCodeBanking. Bye \n</prosody>\n</prosody>\n</amazon:auto-breaths>\n</speak>',
        Voice: "Joanna",
        GlobalEngine: "Standard",
      },
    },
    {
      Results: "Success",
      ContactId: "895a1290-243d-4326-ae99-28a75b733f32",
      ContactFlowId:
        "arn:aws:connect:us-east-1:480876436154:instance/445dd2de-e303-485f-8c09-348bbcf4b582/contact-flow/a216def9-acd0-4763-9b98-a768d9558170",
      ContactFlowName: "NorthCodeBankingDemoBalanceXXX",
      ContactFlowModuleType: "PlayPrompt",
      Timestamp: "2023-01-20T12:14:51.384Z",
    }]

    let m1 = [
      {
        ContactId: "895a1290-243d-4326-ae99-28a75b733f32",
        ContactFlowId:
          "arn:aws:connect:us-east-1:480876436154:instance/445dd2de-e303-485f-8c09-348bbcf4b582/contact-flow/efc920a7-5f00-44ad-8da6-80d644b43782",
        ContactFlowName: "NorthCodeBankingDemo",
        ContactFlowModuleType: "SetLoggingBehavior",
        Timestamp: "2023-01-20T12:14:15.653Z",
        Parameters: {
          LoggingBehavior: "Enable",
        },
      },
      {
        ContactId: "895a1290-243d-4326-ae99-28a75b733f32",
        ContactFlowId:
          "arn:aws:connect:us-east-1:480876436154:instance/445dd2de-e303-485f-8c09-348bbcf4b582/contact-flow/efc920a7-5f00-44ad-8da6-80d644b43782",
        ContactFlowName: "NorthCodeBankingDemo",
        ContactFlowModuleType: "PlayPrompt",
        Timestamp: "2023-01-20T12:14:15.654Z",
        Parameters: {
          TextToSpeechType: "text",
          SpeakingStyle: "",
          Text: "Thank you for calling NorthCode banking today",
          Voice: "Joanna",
          GlobalEngine: "Standard",
        },
      },
      {
        ContactId: "895a1290-243d-4326-ae99-28a75b733f32",
        ContactFlowId:
          "arn:aws:connect:us-east-1:480876436154:instance/445dd2de-e303-485f-8c09-348bbcf4b582/contact-flow/efc920a7-5f00-44ad-8da6-80d644b43782",
        ContactFlowName: "NorthCodeBankingDemo",
        ContactFlowModuleType: "GetUserInput",
        Timestamp: "2023-01-20T12:14:19.334Z",
        Parameters: {
          TextToSpeechType: "ssml",
          Timeout: "5000",
          Text: '<speak>\n<amazon:auto-breaths>\n<prosody rate="medium" >\n<prosody rate="-4%" >\nYou will now hear <emphasis level="moderate">4</emphasis> options, you can make your selection at any time!\n<break time="0.4s"/>\nIf you have lost your card, or had it stolen, press 1.\n<break time="0.4s"/>\nFor balance inquiries, press 2.\n<break time="0.4s"/>\nTo lodge a complaint, press 3.\n<break time="0.4s"/>\nTo talk to an agent, press 4.\n</prosody>\n</prosody>\n</amazon:auto-breaths>\n</speak>',
          Voice: "Joanna",
          MaxDigits: "1",
        },
      },

      {
        ContactId: "895a1290-243d-4326-ae99-28a75b733f32",
        ContactFlowId:
          "arn:aws:connect:us-east-1:480876436154:instance/445dd2de-e303-485f-8c09-348bbcf4b582/contact-flow/efc920a7-5f00-44ad-8da6-80d644b43782",
        ContactFlowName: "NorthCodeBankingDemo",
        ContactFlowModuleType: "SetAttributes",
        Timestamp: "2023-01-20T12:14:38.099Z",
        Parameters: {
          Value: "balance",
          Key: "keypadSelection",
        },
      },
      
      
      {
        ContactId: "895a1290-243d-4326-ae99-28a75b733f32",
        ContactFlowId:
          "arn:aws:connect:us-east-1:480876436154:instance/445dd2de-e303-485f-8c09-348bbcf4b582/contact-flow/a216def9-acd0-4763-9b98-a768d9558170",
        ContactFlowName: "NorthCodeBankingDemoBalanceXXX",
        ContactFlowModuleType: "Transfer",
        Timestamp: "2023-01-20T12:14:38.101Z",
        Parameters: {
          ContactFlowId:
            "arn:aws:connect:us-east-1:480876436154:instance/445dd2de-e303-485f-8c09-348bbcf4b582/contact-flow/a216def9-acd0-4763-9b98-a768d9558170",
        },

        SubMessages: m2,
      },

      {
        ContactId: "895a1290-243d-4326-ae99-28a75b733f32",
        ContactFlowId:
          "arn:aws:connect:us-east-1:480876436154:instance/445dd2de-e303-485f-8c09-348bbcf4b582/contact-flow/efc920a7-5f00-44ad-8da6-80d644b43782",
        ContactFlowName: "NorthCodeBankingDemo",
        ContactFlowModuleType: "PlayPrompt",
        Timestamp: "2023-01-20T12:14:15.654Z",
        Parameters: {
          TextToSpeechType: "text",
          SpeakingStyle: "",
          Text: "Thank you for calling NorthCode banking today",
          Voice: "Joanna",
          GlobalEngine: "Standard",
        },
      },
      
    ];


    


    return Promise.resolve(m1);
  }
}


export const contactFlowApi = new ContactFlowApi();